import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { ProjectDto } from '../types';

export const useProjects = () => {
  return useQuery<ProjectDto[]>({
    queryKey: ['projects'],
    queryFn: () => apiClient.get('/v1/projects'),
  });
};
